import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class BlocksService extends EntityService {
  static get entity() {
    return 'booking/reservation/blocks';
  }
}
